import React, { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";
import axios from "axios";
import FormData from "form-data";

const FIELD_MAP = {
  0: [
    ["documentType", "Document Type"],
    ['requestId', 'Request ID']
  ],
  1: [
    ["documentType", "Document Type"],
    ["documentName", "Document Name"],
    ["status", "Status"],
    ["bankName", "Bank Name"],
    ["fromDate", "From Date"],
    ["toDate", "To Date"],
    ["accountNo", "Account Number"],
    ["holderName", "Holder Name"],
    ["ifscCode", "IFSC Code"],
    ["pageCount", "Page Count"],
    ["is10kAvailable", "10K Available"],
    ["islogoPresent", "Logo Present"],
    ['requestId', 'Request ID'],
  ],
  2: [
    ["documentType", "Document Type"],
    ["documentName", "Document Name"],
    ["status", "Status"],
    ["bankName", "Bank Name"],
    ["accountNo", "Account Number"],
    ["holderName", "Holder Name"],
    ["ifscCode", "IFSC Code"],
    ["islogoPresent", "Logo Present"],
    ['requestId', 'Request ID'],
    // ["statuserrorMsg", "Status Error Message"],
  ],
  3: [
    ["documentType", "Document Type"],
    ["documentName", "Document Name"],
    ["status", "Status"],
    ["bankName", "Bank Name"],
    ["accountNo", "Account Number"],
    ["ifscCode", "IFSC Code"],
    ["holderName", "Holder Name"],
    // ["statuserrorMsg", "Status Error Message"],
    ["islogoPresent", "Logo Present"],
    ['requestId', 'Request ID'],
    // ["isEdited", "Is Edited"],
    // ["editedReason", "Edited Reason"],
    // ["editederrorMsg", "Edited Error Message"],
    // ["pageCount", "Page Count"],
  ],
};

function BankAddition() {
  const [img, setImg] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result
        .replace("data:", "")
        .replace(/^.+,/, "");
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = () => {
    if (!img) return alert("Please upload an image first.");
    setLoading(true);
    setData(null);

    // console.log("Image to be sent:", img);
    // const form = new FormData();
    // form.append("ImageByte", `b'${img}'`);

    // axios({
    //   method: "post",
    //   // url: "https://8v8dut1sue.execute-api.ap-south-1.amazonaws.com/default/financialproof",
    //   url: "https://eelflt9h9l.execute-api.ap-south-1.amazonaws.com/default/bank_addition",
    //   headers: {
    //     "x-api-key": "HI0pE07nUA8zW0mzQ2OC97gKnU6WVixl27kisdc4",
    //     authorizationToken: "43ttM0fR6IJ8JWMA",
    //   },

    //   data: form,
    // })
    //   .then((res) => {
    //     setData(res.data);
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     setLoading(false);
    //     alert("Something went wrong with the server");
    //     console.error(err);
    //   });


    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "dVT9ufCLSF6MYbzZUJIt8EMW7Gcry4P2pYxZdRj2");
    myHeaders.append("authorizationToken", "43ttM0fR6IJ8JWMA");

    const formdata = new FormData();
    // form.append("ImageByte", img);
    formdata.append("ImageByte", img);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow"
    };

    fetch("https://8f4x2xvcbj.execute-api.ap-south-1.amazonaws.com/default/demo-bank-addition", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result)
        setData(result);
        setLoading(false);
      })
      .catch((error) => console.error(error));

  };

  const renderData = () => {
    if (!data || !data.documentType) return null;

    const fields = FIELD_MAP[data.documentType] || [
      ["documentType", "Unknown Type"],
    ];
    return (
      <table className="table">
        <tbody>
          {fields.map(([key, label]) => (
            <tr key={key}>
              <th width="30%">{label}</th>
              <td>{String(data[key] ?? "-")}</td>
            </tr>
          ))}
          {"statuserrorMsg" in data && data.statuserrorMsg && (
            <tr>
              <th>Status Message</th>
              <td>{data.statuserrorMsg}</td>
            </tr>
          )}
          {"isEdited" in data && (
            <>
              <tr>
                <th>Is Edited</th>
                <td>{data.isEdited ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <th>Edited Reason</th>
                <td>{data.editedReason || "-"}</td>
              </tr>
            </>
          )}
          {"isLatest" in data && (
            <>
              <tr>
                <th>Is Latest</th>
                <td>{data.isLatest ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <th>Latest Error</th>
                <td>{data.islatesterrorMsg || "-"}</td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    );
  };

  return (
    <div className="container containerBoreder">
      <h2 className="pageTitle">Bank Document Upload</h2>
      <div className="row">
        <div className="col-4">
          <input type="file" onChange={onChange} />
        </div>
        <div className="col-4">
          {loading ? (
            <ReactBootStrap.Spinner animation="border" />
          ) : (
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          )}
        </div>
      </div>
      <br />
      {data && renderData()}
    </div>
  );
}

export default BankAddition;